require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// ./~/babel-polyfill/~/core-js/modules/es6.array.species.js
// module id = 532
// module chunks = 4